var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import color from "detail/utils/color";
import { useSelector } from 'react-redux';
import Title from './title';
import Tab from './tab';
import Loading2 from "../main/loading2";
var Review = function () {
    var itemLoaded = useSelector(function (state) { return state.product.itemLoaded; });
    return (React.createElement(Style, null,
        React.createElement(Title, null),
        itemLoaded
            ? React.createElement(Tab, null)
            : React.createElement(Loading2, null)));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 2px solid #333;\n\n    position: relative;\n\n    /**\n     * \uACF5\uC6A9\n     * hoverPointer, text-bar\n     * */\n    .hoverPointer{cursor:pointer;}\n    .text-bar{\n        display:inline-block;\n        width:1px;\n        background:", ";\n        margin:0 8px;\n        height:10px;\n    }\n"], ["\n    border-top: 2px solid #333;\n\n    position: relative;\n\n    /**\n     * \uACF5\uC6A9\n     * hoverPointer, text-bar\n     * */\n    .hoverPointer{cursor:pointer;}\n    .text-bar{\n        display:inline-block;\n        width:1px;\n        background:", ";\n        margin:0 8px;\n        height:10px;\n    }\n"])), color.colorD5);
export default Review;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/index.tsx
// module id = 239
// module chunks = 0